module.exports = __webpack_public_path__ + "img/CTE5.36907ff6.png";